import React from 'react';
import LegalDocument from '../legal/LegalDocument';
import {termsSections} from '../legal/termsContent';
export default function TermsOfService(){
 return <LegalDocument title="Terms of Service" otherHref="/privacy-policy" otherLabel="Privacy Policy" sections={termsSections} summary={[
  'Use and share only content you have permission to use. Get any required recording permissions and follow game and competition rules.',
  'Selected payers approve their team’s billing arrangement and applicable changes. Routine renewals can then happen automatically without a new approval each month.',
  'Review prices, payer shares, trial terms, renewal dates, and cancellation confirmation in Billing. A status notification is not a payment receipt.',
  'YouTube videos remain hosted by YouTube, and public or unlisted links are not made private by your team’s permissions.',
  'Keep copies of important content. Platform limits, external providers, and experimental features can affect availability. Mandatory consumer and privacy rights remain protected.'
 ]}/>;
}
